<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .select-header
      .select-btn-wrapper
        .btn-deselect-all(@click="rowSelect('none')" :class="{ 'active' : leagueAllDeselected == true} ") {{ $t("ui.deselect_all") }}
        .btn-select-all(@click="rowSelect('all')" :class="{ 'active' : leagueAllSelected == true} ") {{ $t("ui.select_all") }}
      a(href="javascript:void(0);" @click="saveLeague")
        .btn-done {{ $t("ui.done") }}
    template(v-for="(sItem, sKey, sIndex) in sports")
      template(v-if="getFilterLeagueList(sKey).length > 0")
        .select-league
          template(v-for="(lItem, lKey, lIndex) in getFilterLeagueList(sKey)")
            .single-league
              label.remember.d-flex
                .check-wrap
                  input(type="checkbox" :checked="checkLeague(lItem)" @click="rowSelect(lItem)")
                  span.checkmark
                .blue.flex-grow-1 {{ lItem[4] }}
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config"

export default {
  components: {
    toolBar,
    footerNav,
    Marquee
  },
  data() {
    return {
      lastInitialized: 0,
      leagueIdSelected: [],
      leagueAllDeselected: false,
      leagueAllSelected: true
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  mounted() {
    this.initial();
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    initial() {
      this.leagueIdSelected = [];
      if (this.$store.getters.selectLeague != null) {
        if (this.$store.getters.selectLeague.length > 0) {
          this.leagueIdSelected = this.$store.getters.selectLeague.slice();
          this.leagueAllSelected = this.$store.getters.selectLeague.length == Object.values(this.$store.state.layout.league).length ? true : false;
        } else {
          var tempList = Object.values(this.$store.state.layout.league);
          for (var i = 0; i < tempList.length; i++) {
            this.leagueIdSelected.push(tempList[i][0]);
          }
          this.leagueAllSelected = true;
        }
      }
    },
    leaguesList() {
      if (this.$store.state.layout.league != null) {
        var tempList = Object.values(this.$store.state.layout.league).sort((a, b) => {
          if (a[4] < b[4]) return -1;
          if (a[4] > b[4]) return 1;
          return 0;
        });;
        return tempList;
      } else {
        return null;
      }
    },
    getFilterLeagueList(sportId) {
      let llnn = this.leaguesList();

      if (llnn) {
        return this.leaguesList().filter(item => {
          return item[1] == sportId;
        });
      } else {
        return [];
      }
    },
    rowSelect: function(info) {
      if (!["all","none"].includes(info)) {
        var index = this.leagueIdSelected.indexOf(info[0]);
        if (index == -1) {
          this.leagueIdSelected.push(info[0]);
          this.leagueAllSelected = this.leagueIdSelected.length == Object.values(this.$store.state.layout.league).length ? true : false;
          this.leagueAllDeselected = this.leagueIdSelected.length > 0 ? false : true;
        } else {
          this.leagueIdSelected.splice(index, 1);
          this.leagueAllSelected = false;
          this.leagueAllDeselected = this.leagueIdSelected.length == 0;
        }
      } else {
        this.leagueAllSelected = info == "all" ? true : false;
        this.leagueAllDeselected = info == "none" ? true : false;
        if (this.$store.state.layout.league != null) {
          var tempList = Object.values(this.$store.state.layout.league);

          setTimeout(() => {
            if (this.leagueAllSelected) {
              for (var i = 0; i < tempList.length; i++) {
                var index = this.leagueIdSelected.indexOf(tempList[i][0]);
                if (index == -1) this.leagueIdSelected.push(tempList[i][0]);
              }
            } else {
              this.leagueIdSelected = [];
            }
          }, 10);
        }
      }
    },
    checkLeague(league) {
      return this.leagueIdSelected.indexOf(league[0]) >= 0;
    },
    saveLeague() {
      this.$store.dispatch("layout/setSelectLeague", this.leagueIdSelected);
      this.$router.push("/prematch").catch(err => {});
    }
  }
};
</script>
